import { Injectable } from '@angular/core';
import { OeAppService } from '../shared/oe-app.service';
import { Observable } from 'rxjs';
import { OeAppPersonService } from '../shared/oe-app-person.service';
import { HttpClient } from '@angular/common/http';
import { TestResultDto } from '../shared/types/TestResultDto';

@Injectable({
  providedIn: 'root'
})
export class LevelTestResultsService {

  constructor(private http: HttpClient, private oeAppService: OeAppService, private oeAppPersonService: OeAppPersonService) { }

  getTestResults(): Observable<TestResultDto[]> {
    const url = `${this.oeAppService.courseServiceHost}/v1/level-tests?contactId=${
      this.oeAppPersonService.contactId}`;
    return this.http.get<TestResultDto[]>(url);
  }
}



// WEBPACK FOOTER //
// ./ts/app/test-results/level-test-results.service.ts